import { StyledPillButton, text } from "@quickpoint.me/shared";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { LocaleAtom } from "../../state/localeAtom";
import { InPresentationModeSelector } from "../../state/selectors";
import { ShowLandscapePreview, ShowPortraitPreview } from "../../state/uiAtoms";

/**
 * The app's primary action, anchored at the far right of the top bar
 * (Figma/Slides convention) as the one filled pill in the chrome.
 */
function PresentControl() {
	useRecoilValue(LocaleAtom); // re-render on locale change
	const setPortrait = useSetRecoilState(ShowPortraitPreview);
	const setLandscape = useSetRecoilState(ShowLandscapePreview);
	const [inPresentationMode, setInPresentationMode] = useRecoilState(
		InPresentationModeSelector,
	);

	const handlePresent = () => {
		setPortrait(false);
		setLandscape(true);
		setInPresentationMode(!inPresentationMode);
	};

	return (
		<StyledPillButton
			data-testid="present-button"
			onClick={handlePresent}
			aria-label={text.preview.presentLabel}
		>
			{text.preview.present}
		</StyledPillButton>
	);
}

export default PresentControl;
